<template>
  <div class="navbar-container d-flex content align-items-center">
    <BannerNotif />

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="GridIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <b-navbar-nav class="nav align-items-center mr-auto d-none d-lg-flex">
      <span class="brand-logo">
        <b-img
          :src="appLogoImage"
          alt="logo"
        />
      </span>
      <h2 class="brand-text">
        {{ appName }}
      </h2>
    </b-navbar-nav>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none">
      <!-- Bookmarks Container -->
      <bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <user-dropdown />
      <notification-dropdown v-if="false" />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BImg,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import Bookmarks from './components/Bookmarks.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import BannerNotif from './components/BannerNotification.vue'

export default {
  components: {
    BLink,
    BImg,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    NotificationDropdown,
    UserDropdown,
    BannerNotif,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      // App Name
      appName,
      appLogoImage,
    }
  },
  data() {
    return {
      isDevEnv: false,
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname
      this.isDevEnv = host === 'localhost' || host === '127.0.0.1' || host.includes('dev') || host.includes('staging') || host.startsWith('192.168.')
    }
  },
  methods: {
    switchToNewVersion(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }

      // Selalu simpan state versi ke localStorage
      localStorage.setItem('komerce_version', 'v2')
      if (window.parent && window.parent !== window) {
        // Jika berada di dalam Iframe (dari host React), kirim pesan postMessage
        window.parent.postMessage({ type: 'SWITCH_LAYOUT_VERSION', version: 'v2' }, '*')
      } else {
        // Jika berjalan mandiri (Standalone) baik di dev maupun prod/staging
        // Arahkan ke host React (VUE_APP_BASE_AUTH_MODULE)
        const reactHost = process.env.VUE_APP_BASE_AUTH_MODULE || ''
        const cleanReactHost = reactHost.endsWith('/') ? reactHost.slice(0, -1) : reactHost
        const safePath = window.location.pathname.startsWith('/') ? window.location.pathname : `/${window.location.pathname}`
        // Buat url baru dengan parameter komerce_version=v2
        const queryParams = window.location.search
          ? `${window.location.search}&komerce_version=v2`
          : '?komerce_version=v2'
        window.location.href = `${cleanReactHost}${safePath}${queryParams}`
      }
    },
  },
}
</script>
